import { prefersMobileDevice } from './partnerUploadFile';

const revokers = new Set();
let fileProcessing = false;

export function shouldHideCameraPreview(cameraOnly = false) {
  return Boolean(cameraOnly && prefersMobileDevice());
}

export function registerSignupPreviewRevoker(revokeFn) {
  if (typeof revokeFn !== 'function') return () => {};
  revokers.add(revokeFn);
  return () => revokers.delete(revokeFn);
}

export function releaseAllSignupPreviews() {
  revokers.forEach((revokeFn) => {
    try {
      revokeFn();
    } catch {
      // ignore
    }
  });
}

export function beginSignupFileProcessing() {
  if (fileProcessing) return false;
  fileProcessing = true;
  return true;
}

export function endSignupFileProcessing() {
  fileProcessing = false;
}

export function isSignupFileProcessing() {
  return fileProcessing;
}
